import { Button, createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LocationProvider } from "./LocationContext";
import AppRouter from "./Routes";

const App = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

  // Theme configuration
  const theme = createTheme({
    palette: {
      primary: {
        main: "#2C3E50",
        light: "#34495E",
        contrastText: "#ffffff",
      },
      secondary: {
        main: "#E74C3C",
      },
      background: {
        default: "#ECEFF1",
        paper: "#FFFFFF",
      },
      text: {
        primary: "#2C3E50",
        secondary: "#7F8C8D",
      },
    },
    typography: {
      fontFamily: "'Roboto', 'Arial', sans-serif",
    },
    shadows: ["none", "0px 1px 3px rgba(0, 0, 0, 0.2)"],
  });

  // Add `beforeinstallprompt` event listener
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault(); // Prevent the browser's default install prompt
      setDeferredPrompt(e); // Save the event for later use
      setShowInstallButton(true); // Show the install button
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  // Handle install button click
  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // Show the install prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");
        } else {
          console.log("User dismissed the install prompt");
        }
        setDeferredPrompt(null); // Clear the saved event
        setShowInstallButton(false); // Hide the install button
      });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocationProvider>
        <AppRouter />
        {showInstallButton && (
          <div style={{ position: "fixed", bottom: 16, right: 16 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleInstallClick}
              style={{
                padding: "10px 16px",
                fontWeight: "bold",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
              }}
            >
              Install App
            </Button>
          </div>
        )}
      </LocationProvider>
    </ThemeProvider>
  );
};

export default App;
